const locale = {
    placeholder: 'Pilih waktu',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/id_ID.tsx